import { updateMetricByKey } from '@client/core/atoms/metrics.js';
import { updatePlacementKeyValueById } from '@client/core/atoms/placements.js';
import {
  debugLog,
  type PlacementId,
  PlacementStatus,
  type AfsPlacementId,
  type FinnLegendaryAfsPlacementId,
  type AdStatus
} from '@schibsted-nmp/advertising-shared';

import { Api } from './Api/index.js';
import type { Interface } from './Api/Interface.js';
import { staggerAfsRequests } from './utils/staggerAfsRequest.js';

const afsRequest = (
  container: AfsPlacementId | FinnLegendaryAfsPlacementId,
  options: Interface.Parameters.PageLevel
) => {
  if (!options.query) return;

  debugLog(`Triggering AFS request for container: ${container}`);
  updatePlacementKeyValueById(container, 'status', 'requested');
  updatePlacementKeyValueById(container, 'creativeType', 'banner');

  if (window.location.hostname.includes('local')) {
    updateMetricByKey(container, PlacementStatus.AdLoaded);
    updatePlacementKeyValueById(container, 'status', 'loaded');
    renderAFSPlaceholder(container);
    return;
  }

  try {
    Api()('ads', options, {
      container,

      adLoadedCallback: (...args) => {
        const [, loadIsSuccessful] = args;
        const placementStatus = loadIsSuccessful
          ? PlacementStatus.AdLoaded
          : PlacementStatus.AdNoFill;
        const adStatus: AdStatus = loadIsSuccessful ? 'loaded' : 'error';

        updateMetricByKey(container, placementStatus);
        updatePlacementKeyValueById(container, 'status', adStatus);
        debugLog(`Arguments from adLoadedCallback: ${JSON.stringify(args)}`);
      }
    }).catch((error: unknown) => {
      debugLog('Error in google ad sense [for search]: ', error);
    });

    updateMetricByKey(container, PlacementStatus.AdRequested);
  } catch (error) {
    debugLog('Error in google ad sense [for search]: ', error);
  }
};

export function triggerAfsRequest(
  container: AfsPlacementId | FinnLegendaryAfsPlacementId,
  options: Interface.Parameters.PageLevel
) {
  staggerAfsRequests(() => {
    afsRequest(container, options);
  });
}

function renderAFSPlaceholder(placementId: PlacementId) {
  setTimeout(() => {
    const slotElement = document.getElementById(placementId);
    if (!slotElement) return;

    const placeholder = document.createElement('div');

    Object.assign(placeholder.style, {
      backgroundColor: '#f0f0f0',
      border: '1px solid #ccc',
      borderRadius: '10px',
      width: '100%',
      height: '396px',
      lineHeight: '396px',
      textAlign: 'center'
    } as CSSStyleDeclaration);

    placeholder.textContent = 'Adsense placeholder';
    slotElement.innerHTML = '';
    slotElement.appendChild(placeholder);
  }, 50);
}
